<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  min-height: 100%;
  background-color: #E8ADAA;
  padding-bottom: 70px;
}

html, body {
  height: 100%;
  background-color: #f5f5f5;
}

.btn-nav {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

/* Small phones (iPhone) */
@media all and (max-width: 597px) {
  .insult {
    padding-top: 5%;
    font-size: 300%;
    word-break: keep;
  }
}

/* Big phones */
@media all and (min-width: 598px) and (max-width: 999px) {
  .insult {
    padding-top: 10%;
    font-size: 400%;
    word-break: keep;
  }
}

/* Desktops */
@media all and (min-width: 1000px) {
  .insult {
    padding-top: 20%;
    font-size: 500%;
    word-break: keep;
  }
}
</style>
